export default {
    CADASTRO_DOMICILIAR: 1,
    CADASTRO_INDIVIDUAL: 2,
    ATENDIMENTO_INDIVIDUAL: 3,
    ATENDIMENTO_ODONTOLOGICO: 4,
    ATIVIDADE_COLETIVA: 5,
    VISITA_DOMICILIAR: 6,
    PROCEDIMENTOS: 7,
    ATENDIMENTO_DOMICILIAR: 8,
    AVALIACAO_ELEGIBILIDADE_ADMISSAO: 9,
    MARCADORES_DE_CONSUMO_ALIMENTAR: 10,
    FICHA_COMPLEMENTAR: 11,
    FICHA_DE_VACINACAO: 12,
}